module.exports = __webpack_public_path__ + "img/Logo_IC_Setembro_Amarelo_semBorda630x400.e920a71b.svg";